// extracted by mini-css-extract-plugin
export default {"input":"kpa-z","button":"lpa-z","selected":"mpa-z","sephoraImage":"npa-z","unavailable":"opa-z","image":"ppa-z"};